import { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
    Box,
    Stack,
    IconButton,
    Tooltip,
    Divider
} from '@mui/material';

import { IoMdRefresh } from 'react-icons/io';

import { Icon as Iconify } from '@iconify/react';
import ModalPopUp from '../../../commons/ModalPopup';
import { renderControls } from '../../RetailerProductWiseScheme/utils/renderControls';
import PopUpHandle from '../../../commons/PopUpHandle';
import RetailerWiseProductWiseSchemeService from '../../RetailerProductWiseScheme/RetailerWiseProductWiseSchemeService';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import { useAppStore } from '../../../store/appStore';


export default function RetailerWiseProductWiseSchemeFilterSearch({ open, onClose }) {

    const {
        handleSubmit,
        control,
        watch,
        setValue,
        reset

    } = useForm();

    const values = watch();
    const {
        searchControls,
        setFilterControlValues, filterControlValues,
        setHoverFilterValues, setFilteredData, filteredData,
        setFilterPayload
    } = useAppStore();

    const [loading, setLoading] = useState(false)

    const [opene, setOpene] = useState(false);
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState(0);


    const handleClose = () => {
        setOpene(false);
    };


    const isResetting = useRef(false);







    useEffect(() => {

        isResetting.current = true;
        if (filterControlValues && Object.keys(filterControlValues).length > 0) {
            reset(filterControlValues); // Use reset to populate the form
        } else {
            reset({}); // Reset to an empty state
        }
        setTimeout(() => {
            isResetting.current = false;
        }, 100);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);



    const [serviceInstance, setServiceInstance] = useState(null);

    useEffect(() => {
        const setInstance = async () => {
            const instance = await RetailerWiseProductWiseSchemeService;
            setServiceInstance(instance);
        };
        setInstance();
    }, []);

    const onSubmit = async (data) => {
        console.log('searchControls', searchControls);
        console.log('data', data);

        //  Resolve ShowDetails once (no ternary nesting)
        const showDetailsValue = data?.ShowDetails === true ? "1" : "0";
        

        setFilterControlValues(data);

        try {
            setLoading(true);

            const schemeConversionFilterServiceInstance =
                await RetailerWiseProductWiseSchemeService;

            if (!schemeConversionFilterServiceInstance) {
                throw new Error("Service instance could not be created");
            }

            //  ALWAYS-BUILT PAYLOAD (fixed structure)
            const payload = {
                SchemeIds: data?.SchemeName?.length
                    ? data.SchemeName.map(s => s.SchemeId)
                    : [],
                FromDate: data?.FromDate || "",
                ToDate: data?.ToDate || "",
                Description: data?.Description || "",
                ShowDetails: showDetailsValue
            };

            setHoverFilterValues(data);
            setFilterPayload(payload);

            const response =
                await schemeConversionFilterServiceInstance
                    .GetRetailerProductSchemeClaimReport(payload);

            setFilteredData(response?.data || []);

            onClose();
        } catch (err) {
            console.log('error', err);

            setErrorCode(err?.response?.data?.error?.code);
            setError(err?.response?.data?.error?.message);
            setOpene(true);

            if (err?.response?.data?.error?.code === 404) {
                setFilteredData([]);
            }
        } finally {
            setLoading(false);
        }
    };




    const handleReset = () => {
        reset({
            SchemeName: [],
            FromDate: "",
            ToDate: "",
            Description: "",
            ShowDetails: 0
        });       
    };








    return (


        // eslint-disable-next-line react/jsx-boolean-value
        <ModalPopUp open={open} onClose={onClose} title='Filter'
        // sx={{ width: { xs: 320, sm: 520, md: 680 } }}
        >
            <form onSubmit={handleSubmit(onSubmit)}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    minHeight: 0,

                }}
            >
                <Stack spacing={2} sx={{
                    pb: 1.3, pt: 0.1, display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    minHeight: 0,
                    overflow: 'hidden' // Prevent overflow in the Stack
                }}>
                    <Box
                        sx={{
                            overflow: "visible", // instead of "auto"
                            rowGap: 2,
                            columnGap: 2,
                            display: 'grid',
                            // gridTemplateColumns='repeat(4, 1fr)'
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: '1fr',
                                md: '1fr 1fr',
                                lg: '1fr 1fr ',
                                xl: '1fr 1fr 1fr'
                            },
                            gridAutoRows: 'min-content',
                            paddingTop: '0.4rem',
                            // border: '2px solid red',
                        }}
                    >
                        {searchControls?.map((field, index) => renderControls(field, index, control, serviceInstance?.SearchFilter))}

                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip title='Reset' sx={{ bgcolor: '#fdd835', color: '#fff', borderRadius: '4px', height: "34px", width: "34px", padding: "5px" }}>
                            <IconButton onClick={handleReset}>
                                <IoMdRefresh />
                            </IconButton>
                        </Tooltip>
                        <Tooltip
                            title='Apply'
                            sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', marginLeft: '8px', height: "34px", width: "34px", padding: "5px" }}
                        >
                            <IconButton type='submit'>
                                <Iconify icon='mdi:filter' />
                            </IconButton>
                        </Tooltip>
                    </Box>

                </Stack>
            </form>
            {loading && <LoadingProgressBar />}
            {opene && <PopUpHandle open={opene} handleClose={handleClose} error={error} errorCode={errorCode} />}
        </ModalPopUp>

    );

}

RetailerWiseProductWiseSchemeFilterSearch.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};